import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Subscription } from 'rxjs';
import { useGeneralContext } from '../../services/GeneralContext';
import GeneralHelper from '../Helpers/GeneralHelper';
import './DevBar.scss';

export interface DevBarInfo {
  description: string;
  id: string;
}

const DevBar: React.FC = () => {
  if (!GeneralHelper.isDevelopmentEnvironment()) {
    return <></>;
  }

  const { updateDevBarData$ } = useGeneralContext();

  const [devBarData, setDevBarData] = useState<DevBarInfo | null>(null);

  const [messageToDisplay, setMessageToDisplay] = useState<string | null>(null);
  const [messageIsDisplayed, setMessageIsDisplayed] = useState<boolean>(false);

  const location = useLocation();

  // When the URL changes, reset the dev bar data so the page is responsible for updating it
  useEffect(() => {
    setDevBarData(null);
  }, [location]);

  useEffect(() => {
    const allSubscriptions = new Subscription();

    // In some cases, like when we impersonate a user, we need to refresh the app's state
    // entirely, so we use a state variable to unmount/remount the app's core components,
    // which will rerun initialization logic
    allSubscriptions.add(
      updateDevBarData$.subscribe((data) => {
        setDevBarData(data);
      })
    );

    return () => {
      allSubscriptions.unsubscribe();
    };
  }, [updateDevBarData$]);

  return (
    <div className={`devBar ${!devBarData ? 'isHidden' : ''}`}>
      <div className="d-flex h-100">
        <div className="fg-1 d-flex aic gap-2 ms-4">
          <i className="fa-regular fa-square-terminal c-white"></i>
          <span className="c-white">Developers</span>
        </div>

        {messageToDisplay ? (
          <div className={`messageToDisplay ${messageIsDisplayed ? 'isDisplayed' : ''} d-flex aic jce`}>{messageToDisplay}</div>
        ) : (
          <></>
        )}

        {devBarData ? (
          <div className="d-flex aic jce gap-2 me-4 c-white">
            <span className="descriptionText">{devBarData.description}</span>

            <div
              className="devBarDataText d-flex aic"
              // NOTE: We have the copy icon container, but we copy when the user clicks anywhere in this area
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                navigator.clipboard.writeText(devBarData.id);

                setMessageToDisplay('Copied to clipboard');

                // Delay this slightly so the CSS animations work
                setTimeout(() => {
                  setMessageIsDisplayed(true);
                });

                // Hide things
                setTimeout(() => {
                  setMessageIsDisplayed(false);

                  setTimeout(() => {
                    setMessageToDisplay(null);
                  }, 500);
                }, 1_000);
              }}
            >
              <span className="idText">{devBarData.id}</span>

              <div className="copyIconContainer">
                <i className="fa-regular fa-copy c-white"></i>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default DevBar;
